import { useMemo } from "react";
import { useAppSelector } from "../hooks";
import { useTranslation } from "react-i18next";

export const useSignIn = () => {
  const data = useAppSelector(({ auth }) => auth.user);
  const status = useAppSelector(({ auth }) => auth.status);

  return {
    data,
    status,
  };
};

export const useSignInWithGoogle = () => {
  const data = useAppSelector(({ auth }) => auth.user);
  const status = useAppSelector(({ auth }) => auth.status);

  return {
    data,
    status,
  };
};

export const useRequestPhoneNumberOtp = () => {
  const status = useAppSelector(({ auth }) => auth.requestPhoneNumberOtpStatus);

  return {
    status,
  };
};

export const useSignInWithPhoneNumber = () => {
  const data = useAppSelector(({ auth }) => auth.user);
  const status = useAppSelector(({ auth }) => auth.status);

  return {
    data,
    status,
  };
};

export const useCheckB2BLoginOption = () => {
  const checkB2BLoginOption = useAppSelector(
    ({ auth }) => auth.checkB2BLoginOption
  );

  return checkB2BLoginOption;
};

export const useChangePassword = () => {
  const status = useAppSelector(({ auth }) => auth.changePasswordStatus);

  return {
    status,
  };
};

export const useRequestPasswordReset = () => {
  const status = useAppSelector(({ auth }) => auth.requestPasswordResetStatus);

  return {
    status,
  };
};

export const useVerifyPasswordResetRequest = () => {
  const status = useAppSelector(
    ({ auth }) => auth.verifyPasswordResetRequestStatus
  );

  return {
    status,
  };
};

export const useResetPassword = () => {
  const status = useAppSelector(({ auth }) => auth.resetPasswordStatus);

  return {
    status,
  };
};

export const useSignInWithB2B = () => {
  const data = useAppSelector(({ auth }) => auth.b2BLogin.data);
  const status = useAppSelector(({ auth }) => auth.status);

  return {
    data,
    status,
  };
};

export const useSignInAutoWithB2B = () => {
  const data = useAppSelector(({ auth }) => auth.user);
  const status = useAppSelector(({ auth }) => auth.status);

  return {
    data,
    status,
  };
};

export const useSignUp = () => {
  const data = useAppSelector(({ auth }) => auth.user);
  const status = useAppSelector(({ auth }) => auth.status);

  return {
    data,
    status,
  };
};

export const useCheckEmail = () => {
  const data = useAppSelector(({ auth }) => auth.emailExist);
  const status = useAppSelector(({ auth }) => auth.emailExistStatus);

  return {
    data,
    status,
  };
};

export const useRegisterToBusinessGroup = () => {
  const status = useAppSelector(
    ({ auth }) => auth.registerToBusinessGroupStatus
  );

  return {
    status,
  };
};

export const useSetPasswordByInvitationToken = () => {
  const status = useAppSelector(
    ({ auth }) => auth.setPasswordByInvitationTokenStatus
  );

  return {
    status,
  };
};
